export default __webpack_public_path__ + "assets/smallSat.cb8c6166.png";